// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimesheetEntry  {
    _originalTypeClassName = "Loom.BO.TimesheetEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimesheetEntry.translate = translateService;
}
this.Id = null;
this.HoursWorked = null;
this.Cost = null;
this.WPCaption = null;
this.Notes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
HoursWorked:any;
Cost:any;
WPCaption:any;
Notes:any;
WorkPackage:any;
Timesheet:any;
static setWorkPackage = ($this, value) => {
var oldValue = $this.WorkPackage;
$this.WorkPackage = value;
if (value != null) {
}
}
static setTimesheet = ($this, value) => {
var oldValue = $this.Timesheet;
$this.Timesheet = value;
if (value != null) {
if (oldValue != null) {
Domain.Timesheet.removeTimesheetEntries(oldValue, $this);
}
Domain.Timesheet.addTimesheetEntries(value, $this);
}
}

static GetCost($this: any): any{return Joove.Common.safeNumber($this?.HoursWorked) * Joove.Common.safeNumber($this?.Timesheet?.EmploymentContract?.HourlyRate);
}
static GetWPCaption($this: any): any{if (($this?.WorkPackage == null)) {return "";}
return $this?.WorkPackage?.FQN;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}